import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-s",
  "use": "arrow-s-usage",
  "viewBox": "0 0 13 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 7\" id=\"arrow-s\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.794 2.095L6.751 6.736A1.04 1.04 0 016.045 7a.995.995 0 01-.699-.264L.295 2.096A.85.85 0 010 1.445C0 1.19.098.976.295.805L.877.27A.963.963 0 011.575 0c.28 0 .512.09.699.27l3.77 3.458L9.817.27a.964.964 0 01.698-.27c.274 0 .51.09.706.27l.582.535a.84.84 0 01.287.642.85.85 0 01-.295.648z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol